import { namespace } from '../../../../../FrontendBundle/Resources/js/ofcs';
import AbstractCommand from './abstractCommand';

/**
 * Set font size command
 *
 * @class SetFontSizeCommand
 * @extends AbstractCommand
 */
export default class SetFontSizeCommand extends AbstractCommand {
    /**
     *
     * @param {SelectionCollection} selection
     * @param {number} size
     */
    constructor(selection, size) {
        super();
        this.selection = selection;
        this.size = size;
        this.oldSizes = {};
        this.oldDefaultLabelSize = selection.first().getParentItem().get('defaultLabelSize');
        this.items = selection.models;
    }

    /**
     * Execute command
     */
    execute() {
        this.oldSizes = {};
        this.items.forEach((item) => {
            this.oldSizes[item.cid] = item.get('fontSize');
            item.set('fontSize', this.size);
        });

        if (this.items.length) {
            this.items[0].getParentItem().set('defaultLabelSize', this.size);
        }

        this.selection.selectItems(this.items, true);
    }

    /**
     * Unexecute command
     */
    unexecute() {
        this.items.forEach(item => item.set('fontSize', this.oldSizes[item.cid]));

        if (this.items.length) {
            this.items[0].getParentItem().set('defaultLabelSize', this.oldDefaultLabelSize);
        }

        this.selection.selectItems(this.items, true);
    }

    /**
     * Return title
     *
     * @return {string}
     */
    getTitle() {
        return `Changed font size to ${this.size}`;
    }
}

namespace('Ofcs.Editor.Command');
window.Ofcs.Editor.Command.SetFontSizeCommand = SetFontSizeCommand;
